<template>

  <div class="row mt-5 support-container" v-if="!isLoading">
    <div class="col-md-12 d-md-flex support-child-container mt-4">
      <div class="mr-2 support-card" v-for="(supportObject,index) in supportList" :key="index">
        {{supportObject.title}}
        <strong>
          <a
            target="_blank"
            class="pl-1"
            :href="supportObject.formattedSupportObj.url"
          >{{supportObject.formattedSupportObj.name}}</a>
        </strong>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Support",
  computed: {
    supportList() {
      let formattedSupportList = [];
      if (this.currentAppData && this.currentAppData.supportList)
        this.currentAppData.supportList.forEach(support => {
          support.formattedSupportObj = JSON.parse(support.value);
          formattedSupportList.push(support);
        });
      return formattedSupportList;
    },
    ...mapGetters(["currentAppData", "isLoading"])
  }
};
</script>

<style scoped>
.support-card {
  border-right: 1px solid black;
  padding: 0px 10px 0px 0px;
}
@media (max-width: 768px) {
  .support-card {
    border: none;
  }
}
.support-card:last-child {
  border-right: none;
}

.support-child-container {

  bottom: 50px;
}
</style>